import * as React from 'react';
import {Component, CSSProperties, ReactNode} from 'react';
import {IStoryData} from '../../../service/contentServer';
import * as queryString from 'querystring';
import {getShareOutParam} from '../../common/ucparam';
import {callShareSDK, getShareOutUrl} from '../../common/share';
import {clickStat} from './shareLine.stat';
import {Country} from '../../../const/env';

if (process.env.BROWSER) {
  require('./shareLine.less');
}

// function getShareOutUrl() {
//   return location.origin + location.pathname + '?' +
//     queryString.stringify(Object.assign(getShareOutParam(), {
//       entry1: 'shareback',
//       entry2: 'page_share_btn',
//       comment_stat: 1,
//     }));
// }

interface IShareLineProps {
  className?: string;
  style?: CSSProperties;
  story: IStoryData;
  country: Country;
}

interface IShareLineState {
}

export default class ShareLine extends Component<IShareLineProps, IShareLineState> {
  constructor(props) {
    super(props);
    this.state = {};

  }

  public callShare() {
    clickStat();
    callShareSDK({
      title: this.props.story.title,
      content: this.props.story.title,
      shareUrl: getShareOutUrl('page_share_btn'),
    });
  }

  public webShareVK() {
    const url = 'http://vk.com/share.php';
    const story = this.props.story;
    const param = {
      url: getShareOutUrl('vk'),
      title: story.title,
      description: document.querySelector<HTMLElement>('.article-content-parsed').innerText.trim().substr(0, 100) + '...',
      image: story.image && story.image[0] && story.image[0].url || undefined,
    };
    const fullUrl = `${url}?${queryString.stringify(param)}`;
    location.href = fullUrl;
  }

  public webShareOK() {
    const url = 'https://connect.ok.ru/offer';
    const story = this.props.story;
    const param = {
      url: getShareOutUrl('ok'),
    };
    const fullUrl = `${url}?${queryString.stringify(param)}`;
    location.href = fullUrl;
  }

  public render(): ReactNode {
    return <div className="w-bottom-compact">
      <div className="action-line">
        <div className="right">
          <div className="w-share-inline">
            <ul className="w-share-content-inline" style={this.props.country === Country.ru ? {width: '80px'} : null} onClick={(e) => {
              e.preventDefault();
              this.props.country !== Country.ru && this.callShare();
            }}>
              {this.props.country === Country.ru
                ?
                <>
                  <li className="w-share-btn w-share-btn-vk" data-id="VK" data-name="VK" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.webShareVK();
                  }}><span><i
                    className="icon-vk icon"/></span></li>
                  < li className="w-share-btn w-share-btn-ok" data-id="OK" data-name="OK" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.webShareOK();
                  }}><span><i
                    className="icon-ok icon"/></span></li>
                </>
                :
                <>
                  <li className="w-share-btn w-share-btn-facebook" data-id="Facebook" data-name="Facebook"><span><i
                    className="icon-facebook icon"/></span></li>
                  < li className="w-share-btn w-share-btn-whatsapp" data-id="Whatsapp" data-name="Whatsapp"><span><i
                    className="icon-whatsapp icon"/></span></li>
                  <li className="w-share-btn w-share-btn-more" data-id="More" data-name="More"><span><i
                    className="icon-more icon"/></span></li>
                </>

              }
            </ul>
          </div>
        </div>
      </div>
    </div>;

  }

}
